import React from "react";
import { CModal, CCard, CCardBody, CButton } from "@coreui/react";

const RejectionReasonModal = ({ visible, onClose, reason }) => {
  return (
    <CModal visible={visible} onClose={onClose} alignment="center" size="lg">
      <CCard className="m-0" style={{ margin: "auto" }}>
        <CCardBody>
          {/* Header */}
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h5 className="mb-0 text-danger">Rejection Reason</h5>
            <CButton color="light" className="p-0" onClick={onClose}>
              <span aria-hidden="true">&times;</span>
            </CButton>
          </div>

          {/* Scrollable Body */}
          <div
            style={{
              border: "1px solid #dee2e6",
              borderRadius: "8px",
              padding: "15px",
              backgroundColor: "#fafafa",
              maxHeight: "400px",
              overflowY: "auto",
              whiteSpace: "pre-wrap",
              lineHeight: 1.5,
            }}
          >
            {reason || "No rejection reason provided."}
          </div>

          {/* Footer */}
          <div className="mt-4">
            <div
              style={{
                backgroundColor: "#fff3cd", // soft yellow background
                borderLeft: "4px solid #ffc107", // yellow accent line
                color: "#856404", // readable dark yellow text
                padding: "12px 16px",
                borderRadius: "6px",
                fontSize: "0.9rem",
                lineHeight: 1.5,
              }}
            >
              <strong>Note:</strong> Please review the reason carefully and make
              the necessary corrections before resubmitting your product for
              approval.
            </div>
          </div>
        </CCardBody>
      </CCard>
    </CModal>
  );
};

export default RejectionReasonModal;
